import { BaseModel } from './base.model'
import * as _ from 'lodash'
import { City } from './city.model'
import { Hub} from './hub.model'
import { HubCourse } from './hub-course.model'
import { Moment } from "moment"
import { Infraction } from './infraction.model'

const WEB_UI_SOURCES = [
  "WebApi::Hubs::Registrations::UpdateService", 
  "WebApi::Hubs::Registrations::CreateService"
]

const TAXOMITER_SOURCES = [
  "PublicWebApi::HubRegistrations::CreateService"
]

export class HubRegistrationInfraction extends BaseModel<HubRegistrationInfraction> {
  detected: boolean
  selectedReasonId: number
  infractionId: number
  infraction: Infraction
}

export class HubRegistration extends BaseModel<HubRegistration> {
  static DEFAULT_ATTRIBUTES = { }

  id: number
  licenseNumber: string
  firstName: string
  lastName: string
  middleName: string
  phone: string
  course: string
  courseSelected: Object
  scheduledAt: Moment
  createdAt: Moment
  ack: string
  city: City
  hub: Hub
  cityId: number
  hubId: number
  hubRegistrationInfractions: HubRegistrationInfraction[]
  hubCourse: HubCourse
  hubTimeIntervalId: number
  hubCourseId: number
  source: string
  uuid: string
  selectedDate: Date
  country: string // country code
  locale: string // locale code
  center_id: number
  driverLicensePersonalId: string

  get sourceType(): string {
    if (this.source && WEB_UI_SOURCES.indexOf(this.source) > -1) {
      return "web_ui"
    }
    else if (this.source && TAXOMITER_SOURCES.indexOf(this.source) > -1) {
      return "taxomiter"
    }
    else {
      return null
    } 
  }

  constructor(attributes = {}) {
    super(attributes)
    if (this.scheduledAt && this.hub.utcOffset){
      this.scheduledAt.utcOffset(this.hub.utcOffset)
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/hub-registration.model.ts